export default __webpack_public_path__ + "static/media/x33-coin.be96d867.svg";